var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKmBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.7176470588235294,
    d: "M 1.5 17 L 8 17.5 L 1.5 18 L 1.5 17 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.7176470588235294,
    d: "M 21.5 17 L 30 17.5 L 21.5 18 L 21.5 17 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,65)",
    stroke: "rgb(0,16,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 15.5 1 L 21.5 5 L 24.5 5 L 30 2 L 30 13 L 1 13 L 1 2.5 L 2.5 2 Q 3.9 5.6 9.5 5 L 15.5 1 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,65)",
    stroke: "rgb(0,16,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1 18 L 7.5 18 L 8 18.5 L 8 52 L 1.5 52 L 1 51.5 L 1 18 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,65)",
    stroke: "rgb(0,16,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 21.5 18 L 30 18.5 L 19 35.5 L 29 52 L 21.5 52 L 19 49.5 L 12 38.5 L 11 33.5 L 21.5 18 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1.5 0 L 14 0.5 L 6.5 4 L 1.5 1 L 1.5 0 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 17.5 0 L 29 0.5 L 22.5 4 Q 17.9 2.8 17.5 0 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 14 L 30.5 14 L 31 17 L 20.5 17 L 19 18.5 L 9.5 34 L 9 17 L 0 17 L 0 14 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 30.5 19 L 31 50.5 L 29 49.5 L 21 36.5 L 21 33.5 L 30.5 19 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 9.5 36 L 20 52.5 L 9 53 L 9.5 36 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,65)",
    stroke: "rgb(0,16,65)",
    strokeWidth: 1,
    opacity: 0.7372549019607844,
    d: "M 0.5 1 L 1 12.5 L 0 12.5 L 0.5 1 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,65)",
    stroke: "rgb(0,16,65)",
    strokeWidth: 1,
    opacity: 0.7372549019607844,
    d: "M 30.5 1 L 31 12.5 L 30 12.5 L 30.5 1 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,65)",
    stroke: "rgb(0,16,65)",
    strokeWidth: 1,
    opacity: 0.7372549019607844,
    d: "M 0.5 18 L 1 52 L 7.5 52 L 8 51.5 L 8 18.5 L 9 18.5 L 9 51.5 L 7.5 53 Q 1.5 54.5 0 51.5 L 0.5 18 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,65)",
    stroke: "rgb(0,16,65)",
    strokeWidth: 1,
    opacity: 0.7372549019607844,
    d: "M 21.5 52 L 30 52.5 L 21.5 53 L 21.5 52 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 14.5 0 L 13.5 2 L 14.5 0 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 29.5 0 L 31 0.5 L 28.5 2 L 29.5 0 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 4.5 2 L 5.5 4 L 4.5 2 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 26.5 2 L 25.5 4 L 26.5 2 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 9.5 3 L 8.5 5 L 7 4.5 L 9.5 3 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 21.5 3 L 24 4.5 L 22.5 5 L 21.5 3 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 0.5 13 L 31 13.5 L 0.5 14 L 0.5 13 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 20.5 17 L 19.5 19 L 20.5 17 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 27.5 23 L 26.5 25 L 27.5 23 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 15.5 25 L 14.5 27 L 15.5 25 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 22.5 31 L 21.5 33 L 22.5 31 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 10.5 33 L 10 34.5 L 11 36.5 L 9 35.5 L 10.5 33 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 21.5 37 L 22.5 39 L 21.5 37 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 12.5 40 L 13.5 42 L 12.5 40 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 24.5 42 L 25.5 44 L 24.5 42 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 14.5 43 L 15.5 45 L 14.5 43 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 26.5 45 L 27.5 47 L 26.5 45 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 17.5 48 L 18.5 50 L 17.5 48 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 29.5 50 L 31 52.5 L 30 52.5 L 29.5 50 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,16,64)",
    stroke: "rgb(0,16,64)",
    strokeWidth: 1,
    opacity: 0.24705882352941178,
    d: "M 19.5 51 L 20.5 53 L 19.5 51 Z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmBlue);
export default __webpack_public_path__ + "static/media/km-blue.33a6bb64e694f57e24a1d51212924559.svg";
export { ForwardRef as ReactComponent };